/**
 * Change disabled status of the submit button
 */

export const Agreement = function() {
	const agreementCheck = document.getElementById("agreement-check");
	if (agreementCheck) {
		const submitId = agreementCheck.dataset.target;
		if (submitId) {
			const submitButton = document.getElementById(submitId);
			checkAgree(agreementCheck, submitButton);
			if (submitButton) {
				agreementCheck.addEventListener("change", (check) => {
					checkAgree(agreementCheck, submitButton);
				});
			}
		}
	}

	function checkAgree(agreementCheck, submitButton) {
		if (agreementCheck.checked) {
			submitButton.disabled = false;
		} else {
			submitButton.disabled = true;
		}
	}
}
